import UserSuggestions, { UserSuggestionsProps } from './UserSuggestions.container';

export type UserSuggestionsType = UserSuggestionsProps;

export default UserSuggestions;
